import { FileServiceResponse } from './interfaces/files-cache.interface';
import { IndexDBService } from './services/index-db.service';
import { ElectronLocalFileSystemService } from './services/electron-local-file-system-service';
import { FILESCACHE_KEYS } from './enums/files-cache.enum';

declare const window: any;

export class CachePlugin {

  public indexDB: IndexDBService = null;
  public electronLocalFileSystemService: ElectronLocalFileSystemService = null;
  public storeData: string = FILESCACHE_KEYS.STORE_VAL;

  public async getFileData(filename: string): Promise<FileServiceResponse> {
    if(this.electronLocalFileSystemService){
      let response = await this.electronLocalFileSystemService.getFile(filename);
      return response;
    } else if(this.indexDB) {
      const response = await this.indexDB.getFile(filename, this.storeData);
      return response;
    }
  }

  public async cacheFileData(filename: string, data: any): Promise<FileServiceResponse> {
    if(this.electronLocalFileSystemService){
      let response = await this.electronLocalFileSystemService.saveFile(filename, data);
      return response;
    } else if(this.indexDB) {
      return await this.indexDB.saveFile(filename, data, this.storeData);
    }
  }

  public async getAllDataByPrefix(prefix: string): Promise<FileServiceResponse[]> {
    if(this.indexDB) {
      return await this.indexDB.getValuesByPrefix(this.storeData, prefix);
    } else {
      return null;
    }
  }

  public async removeFileData(filename: string) {
    if(this.indexDB) {
      await this.indexDB.deleteValue(filename, this.storeData);
    }
  }

  public async removeAllStoreData() {
    if(this.indexDB) {
      await this.indexDB.clearAllStore(this.storeData);
    }
  }

  async checkAccess(): Promise<void> {
    if(this.isElectron() ){
      this.electronLocalFileSystemService = new ElectronLocalFileSystemService();
      await this.electronLocalFileSystemService.removeExpiredFiles();
    } else if (window.indexedDB) {
      this.indexDB = new IndexDBService();
      await this.indexDB.openDB();
    }
  }

  public isElectron() {
    return  window.electronVersions && 'electron' in window.electronVersions ;
  }

}

export const CacheData = {
  install: (Vue) => {
    Vue.prototype.$CacheData = new CachePlugin();
  }
}
